import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import { useRouter } from 'vue-router';
import { useStoreApp } from './app.js';

export const useStoreModal = defineStore('modal', () => {
    const isOpen = ref(false);
    const type = ref(null);
    const context = ref(null);
    let animation = ref({ name: 'fade' });
    let closeButton = ref(true);
    const modalQueue = ref([]);

    const appStore = useStoreApp();

    // Handle hardware back button for webview
    function handleBackButton(event) {
        if (isOpen.value) {
            event.preventDefault();
            event.stopPropagation();
            close(false);
            return false;
        }
    }

    // Setup back button listeners
    function setupBackButtonListener() {
        // For Cordova/PhoneGap
        if (appStore.isAppMobile) {
            document.addEventListener('backbutton', handleBackButton, false);
        }
        // For general webview/PWA - use history API
        else {
            window.addEventListener('popstate', handleBackButton, false);
        }
    }

    // Remove back button listeners
    function removeBackButtonListener() {
        if (appStore.isAppMobile) {
            document.removeEventListener('backbutton', handleBackButton, false);
        } else {
            window.removeEventListener('popstate', handleBackButton, false);
        }
    }

    function open(_type, _context, animate = { name: 'fade' }, queue = false) {
        if (!_type) {
            throw new Error('Type is required');
        }

        if (!_context) {
            throw new Error('Context is required');
        }

        if (animate) {
            animation.value = animate;
        }

        if (isOpen.value && queue) {
            // If modal is already open and queueing is enabled, add to queue
            modalQueue.value.push({ type: _type, context: _context, animate });
            return;
        }

        closeButton.value = false;
        context.value = _context;
        type.value = _type;
        isOpen.value = true;

        // Setup back button listener when modal opens
        setupBackButtonListener();
    }

    function close(payload = true) {
        // Remove back button listener when modal closes
        removeBackButtonListener();

        if (context.value && context.value['callback'] && typeof context.value['callback'] === 'function') {
            context.value['callback'](payload);
        }

        type.value = null;
        context.value = null;
        setTimeout(() => {
            isOpen.value = false;
            animation.value = { name: 'fade' };
            // se c'è un elemento nella queue lo mostriamo e poi lo togliamo dalla queue
            if (modalQueue.value.length > 0) {
                const nextModal = modalQueue.value.shift();
                open(nextModal.type, nextModal.context, nextModal.animate);
            }
        }, 300);
    }

    function toggleCloseButton(value = null) {
        if (value === null) {
            closeButton.value = !closeButton.value;
        } else {
            closeButton.value = value;
        }
    }

    return {
        isOpen,
        type,
        context,
        animation,
        closeButton,
        modalQueue,
        open,
        close,
        toggleCloseButton,
    };
});